{
  "srTitle": "Anti Human Safari Project — protection des civils contre les drones à Kherson, Ukraine",
  "logoAlt": "Logo du projet Anti Human Safari",
  "intro": "Nous fournissons des équipements de protection contre les attaques de petits drones aux bénévoles, aux services d'urgence et aux travailleurs des infrastructures critiques à Kherson, en Ukraine.",
  "safari": "Depuis l'été 2024, les civils de Kherson sont systématiquement traqués par l'armée russe à l'aide de drones vidéo, dans une campagne de terreur connue sous le nom de « Human Safari ».",
  "unLink": "La Commission de l'ONU reconnaît le Human Safari comme un crime de guerre",
  "donateNow": "Faire un don",
  "donateMonthly": "Don mensuel",
  "otherWays": "autres façons de donner",
  "instagram": "Instagram",
  "pastFundraisers": "Collectes passées :",
  "fundraiser2025": "Collecte 2025",
  "donateVia": "Faire un don via :",
  "charityRef": "via une association caritative britannique, avec la référence :",
  "germanCharityRef": "via une association caritative allemande, avec la référence :",
  "copy": "Copier",
  "copied": "Copié !",
  "close": "Fermer",
  "viewMedia": "Voir le média",
  "andrushenkoCredit": "Oleksandr Andrushenko, photocorrespondant du média Vgoru",
  "fruitSellerDescription": "Un vendeur de fruits poursuivi par un drone à fibre optique",
  "khersonPoliceCredit": "de @khersonpolice",
  "firefighterDescription": "Un pompier éteint une voiture après une frappe du « Human Safari », une victime gît derrière",
  "previousMedia": "Précédent",
  "nextMedia": "Suivant",
  "fpvDroneDescription": "Drone FPV en chasse pendant le « Human Safari »",
  "busAttackDescription": "Une des nombreuses attaques de drones FPV contre les transports publics",
  "notFoundTitle": "Page introuvable",
  "notFoundMessage": "Cette page n'existe pas. Elle a peut-être été déplacée ou le lien est erroné.",
  "backHome": "Retour à l'accueil",
  "droneDetectorDescription": "Les détecteurs de drones sont de petits appareils portatifs qui avertissent lorsqu’un drone est proche",
  "vestDescription": "Des gilets de protection légers peuvent réduire la gravité des blessures causées par une attaque de drone"
}
